<template>
    <v-container>
        <v-card width="450">
            <center>
                <v-avatar color="primary" size="56" style="margin:0;">
                    <v-icon dark large>mdi-lock</v-icon>
                </v-avatar>
            </center>
            <v-card-title>
                {{ $t('siteTitle') }}
            </v-card-title>
            <v-card-subtitle class="mb-3 text-center">
                TELTECH - Advanced Phone Systems
            </v-card-subtitle>
            <v-card-text style="padding-bottom: 0;">
                <v-text-field :rules="rules" v-model="username" :label="$t('systemNumber')" outlined
                    append-icon="mdi-phone" @keyup.enter="newLogin"></v-text-field>
                <v-text-field :rules="rules" v-model="password" type="password" :label="$t('password')" outlined
                    append-icon="mdi-key" @keyup.enter="newLogin"></v-text-field>
                <v-checkbox label="מערכת משתמשים" v-model="teltechUser" style="margin-top: -12px !important;"></v-checkbox>
                <v-checkbox label="משתמש פרימיום" v-model="premiumUser" style="margin-top: -12px !important;"></v-checkbox>
                <v-btn color="primary" block @click="newLogin()" :loading="loading">{{ $t('loginToSystem') }}</v-btn>
                <div class="text-center mt-4">
                    <p>אין לך מערכת? <a href="https://www.teltechconference.com/ivr_panel/create_ivr2.php" target="_blank" style="text-decoration: none;">לחץ כאן כדי לפתוח בחינם!</a></p>
                </div>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="loginstatus" :color="sColor">
            {{ status }}
        </v-snackbar>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        username: '',
        user: '',
        password: '',
        loginstatus: false,
        status: '',
        loading: false,
        sColor: '',
        server: 'www',
        teltechUser: false,
        premiumUser: false
    }),
    computed: {
        rules() {
            return [val => (val || '').length > 0 || this.$t('fieldIsRequired')]
        }
    },
    methods: {
        login() {
            this.loading = true;
            (async () => {
                const body = { username: this.username, password: this.password };
                const response = await axios.post('https://call2all.co.il/ym/api/Login', body);
                if (response.data.responseStatus === "OK") {
                    const body1 = { system: this.username, password: this.password };
                    const response1 = await axios.post('/api/users/login', body1);
                    if (response1.data.status == 'SUCCESS') {
                        const body2 = { system: this.username, password: this.password };
                        const response2 = await axios.post('/api/users/check', body2);
                        if (response2.data.status == 'SUCCESS') {
                            this.loading = false;
                            this.loginstatus = true;
                            this.sColor = "green";
                            this.status = this.$t('loginSuccess')
                            sessionStorage.uToken = response1.data.token;
                            sessionStorage.setItem('users', true)
                            sessionStorage.token = response.data.token;
                            sessionStorage.server = 'www';
                            location.href = '/';
                        }
                        else if (response1.data.message == 'System not in teltech') {
                            this.loginstatus = true;
                            this.status = this.$t('systemIsNotInTeltech')
                            this.sColor = "info";
                            this.loading = false;
                        }
                    }
                    else if (response1.data.message == 'User not found') {
                        const body2 = { system: this.username, password: this.password };
                        const response2 = await axios.post('/api/users/check', body2);
                        if (response2.data.status == 'SUCCESS') {
                            this.loading = false;
                            this.loginstatus = true;
                            this.sColor = "green";
                            this.status = this.$t('loginSuccess')
                            sessionStorage.setItem('users', false)
                            sessionStorage.token = response.data.token;
                            sessionStorage.server = 'www';
                            location.href = '/';
                        }
                        else if (response2.data.message == 'System not in teltech') {
                            this.loginstatus = true;
                            this.status = this.$t('systemIsNotInTeltech')
                            this.sColor = "info";
                            this.loading = false;
                        }
                    }
                    else if (response1.data.message == 'Password is incorrect') {
                        this.loginstatus = true;
                        this.status = this.$t('passwordIsIncorrect');
                        this.loading = false;
                        this.sColor = "red";
                    }
                }
                else if (response.data.message === "bruteforce protection - account locked") {
                    this.loginstatus = true;
                    this.status = this.$t('accountLocked')
                    this.loading = false;
                    this.sColor = "red";
                }
                else if (response.data.responseStatus === "FORBIDDEN" || response.data.responseStatus === "EXCEPTION") {
                    const body1 = { system: this.username, password: this.password };
                    const response1 = await axios.post('/api/users/login', body1);
                    if (response1.data.status == 'SUCCESS') {
                        sessionStorage.token = response1.data.ymToken;
                        sessionStorage.uToken = response1.data.token;
                        sessionStorage.setItem('users', true)
                        sessionStorage.server = 'www';
                        this.loading = false;
                        this.loginstatus = true;
                        this.sColor = "green";
                        this.status = this.$t('loginSuccess')
                        location.href = '/';
                    }
                    else {
                        console.log(response1.data)
                        this.loginstatus = true;
                        this.status = this.$t('loginError')
                        this.sColor = "red";
                        this.loading = false;
                    }
                }
                else if (response.data.message === "Login credentials are required") {
                    this.loginstatus = true;
                    this.status = this.$t('systemAndPasswordIsRequired')
                    this.sColor = "warning";
                    this.loading = false;
                }
                else {
                    console.log(response.data)
                    this.loginstatus = true;
                    this.status = this.$t('loginError')
                    this.sColor = "red";
                    this.loading = false;
                }
            })();
        },
        async newLogin() {
            this.loading = true
            // check if the user in teltech
            const body = { token: `${this.username}:${this.password}` }
            const reseller = (await axios.post('https://call2all.co.il/ym/api/GetCustomerData', body)).data
            if (reseller.responseStatus !== 'OK') {
                if (this.teltechUser) {
                    const body1 = { system: this.username, password: this.password };
                    const usersLogin = await axios.post('/api/users/login', body1);
                    if (usersLogin.data.status == 'SUCCESS') {
                        this.loading = false;
                        this.loginstatus = true;
                        this.sColor = "green";
                        this.status = this.$t('loginSuccess')
                        sessionStorage.uToken = usersLogin.data.token;
                        sessionStorage.setItem('users', true)
                        sessionStorage.token = usersLogin.data.ymToken;
                        sessionStorage.server = 'www';
                        location.href = '/';
                    }
                    else {
                        this.loginstatus = true;
                        this.status = this.$t('loginError')
                        this.sColor = "red";
                        this.loading = false;
                    }
                } else {
                    this.loginstatus = true;
                    this.status = this.$t('loginError')
                    this.sColor = "red";
                    this.loading = false;
                }
            }
            else if (reseller.resellerCreditFile !== 'TELTECH' && !this.premiumUser) {
                this.loginstatus = true;
                this.status = this.$t('systemIsNotInTeltech')
                this.sColor = "info";
                this.loading = false;
            }
            else if (this.premiumUser) {
                const body1 = { system: this.username, password: this.password };
                const usersLogin = await axios.post('/api/users/login', body1);
                if (usersLogin.data.status == 'SUCCESS') {
                    this.loading = false;
                    this.loginstatus = true;
                    this.sColor = "green";
                    this.status = this.$t('loginSuccess')
                    sessionStorage.uToken = usersLogin.data.token;
                    sessionStorage.setItem('users', true)
                    sessionStorage.token = usersLogin.data.ymToken;
                    sessionStorage.server = 'www';
                    location.href = '/';
                }
                else if (usersLogin.data.message == 'User not found') {
                    this.loginstatus = true;
                    this.status = this.$t('loginError')
                    this.sColor = "red";
                    this.loading = false
                }
                else {
                    this.loginstatus = true;
                    this.status = this.$t('loginError')
                    this.sColor = "red";
                    this.loading = false;
                }
            }
            else if (reseller.resellerCreditFile == 'TELTECH') {
                const body = { username: this.username, password: this.password }
                const token = (await axios.post('https://call2all.co.il/ym/api/Login', body)).data
                if (token.responseStatus == 'OK') {
                    const body1 = { system: this.username, password: this.password };
                    const usersLogin = await axios.post('/api/users/login', body1);
                    if (usersLogin.data.status == 'SUCCESS') {
                        this.loading = false;
                        this.loginstatus = true;
                        this.sColor = "green";
                        this.status = this.$t('loginSuccess')
                        sessionStorage.uToken = usersLogin.data.token;
                        sessionStorage.setItem('users', true)
                        sessionStorage.token = token.token;
                        sessionStorage.server = 'www';
                        location.href = '/';
                    }
                    else if (usersLogin.data.message == 'User not found') {
                        this.loading = false;
                        this.loginstatus = true;
                        this.sColor = "green";
                        this.status = this.$t('loginSuccess')
                        sessionStorage.setItem('users', false)
                        sessionStorage.token = token.token;
                        sessionStorage.server = 'www';
                        location.href = '/';
                    }
                    else {
                        this.loginstatus = true;
                        this.status = this.$t('loginError')
                        this.sColor = "red";
                        this.loading = false;
                    }
                } else {
                    const body1 = { system: this.username, password: this.password };
                    const usersLogin = await axios.post('/api/users/login', body1);
                    if (usersLogin.data.status == 'SUCCESS') {
                        this.loading = false;
                        this.loginstatus = true;
                        this.sColor = "green";
                        this.status = this.$t('loginSuccess')
                        sessionStorage.uToken = usersLogin.data.token;
                        sessionStorage.setItem('users', true)
                        sessionStorage.token = usersLogin.ymToken;
                        sessionStorage.server = 'www';
                        location.href = '/';
                    } else {
                        this.loginstatus = true;
                        this.status = this.$t('loginError')
                        this.sColor = "red";
                        this.loading = false;
                    }
                }
            }
        }
    },
    beforeMount() {
        this.$drawer = false;
        sessionStorage.clear()
        if (this.$route.query.username && this.$route.query.password) {
            this.username = this.$route.query.username;
            this.password = this.$route.query.password;
            this.newLogin();
        }
    }
}
</script>
<style>
.appnav {
    display: none;
}

.theme--light.v-application {
    background-image: url("../assets/login.jpg");
    background-size: 100%;
}

.v-card__title {
    /* margin-bottom: 20px; */
    justify-content: center;
    font-size: 24px !important;
}

#sub {
    text-align: center;
    margin: -25px 0px 0px 0px;
    font-size: 16px !important;
}

.v-card {
    margin: auto;
    /* margin-top: -10px; */
    font-size: 14px !important;
    padding: 48px 40px 36px;
    min-height: 450px;
    height: auto;
}

.v-btn__content {
    letter-spacing: 0.010714em;
}

.container {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}
</style>